import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SectionComponent } from '../../components/section/section.component';
import { Contact, ContactComponent } from '../../../app/components/contact/contact.component';

import { EditorIdDirective } from '../../../app/directives/editor-id.directive';
import { Section, SectionAttributes } from '../../../app/types/section';
import { FsButtonComponent } from '../../components/fs-button/fs-button.component';

type ContactsSection = Section<
  {
    numColumns: 4;
    color: 'white' | 'blue' | 'gray';
    headline: string;
    contacts: Contact[];
  } & SectionAttributes,
  [
    'headline',
  ],
  'contacts'
>;

@Component({
    selector: 'section[app-contacts]',
    styleUrls: ['./contacts.component.scss'],
    templateUrl: './contacts.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        EditorIdDirective,
        ContactComponent,
        FsButtonComponent,
    ],
})
export class ContactsComponent extends SectionComponent<ContactsSection> {
}
